import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { As2ConnectionConfigModalForm } from '../../forms/As2ConnectionConfigModalForm'
import { useAs2ConnectionConfigModalForm } from '../../forms/useAs2ConnectionConfigModalForm'
import { IAs2ConnectionConfigSchema } from '../../schema/AS2ConnectionConfigSchema'

interface IAs2ConnectionConfigModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onSubmit: (options: IAs2ConnectionConfigSchema) => void
  defaultValues?: {}
}

export const As2ConnectionConfigModal = ({
  defaultValues,
  onClose,
  onSubmit,
  open = false,
  ...props
}: IAs2ConnectionConfigModalProps) => {
  const methods = useAs2ConnectionConfigModalForm({
    /* { identifier: '', outboundUrl: '' } to avoid component changing an uncontrolled
     * input of type text to be controlled error
     */
    defaultValues: defaultValues || {
      identifier: '',
      outboundUrl: '',
      serverInfoCredentialsIdentifier: '',
      transfixIdentifier: 'TFXH',
    },
  })
  const { handleSubmit } = methods

  const submitHandler = handleSubmit((formParams: IAs2ConnectionConfigSchema) => {
    onSubmit(formParams)
    onClose()
  })

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onClose()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Save',
      action: submitHandler,
      type: 'confirm',
      dataTest: 'confirm-button',
    },
  ]

  return (
    <ModalBase
      dataTest='As2ConnectionConfigModal'
      modalType={MODAL_TYPES.form}
      size={4}
      open={open}
      actions={actions}
      onClose={onClose}
      {...props}>
      <FormProvider {...methods}>
        <As2ConnectionConfigModalForm />
      </FormProvider>
    </ModalBase>
  )
}
